import PropTypes from 'prop-types';

import KitoBalloon from '../DataDisplay/Balloon';

import buddyForWave from '../../assets/kitoBuddy/homepage.png';
import whenToWorry from '../../assets/kitoBuddy/Kito-Asking-When-To-Worry 1.png';
import whatToDo from '../../assets/kitoBuddy/Kito-Asking-What-to-do 3.png';
import whatIs from '../../assets/kitoBuddy/Kito-Asking-What-Is 1.png';


import styles from './styles.module.css';

const MascotImage = Object.freeze({
  whatToDo: whatToDo,
  buddyForWave: buddyForWave,
  whatIs: whatIs,
  whenToWorry: whenToWorry,
});

function KitoMascot({ image = 'whatToDo', children, mascotWidth = 120, ...rest }) {
  return (
    <div className={styles.kitoMascot} style={rest}>
      <img width={mascotWidth} src={MascotImage[image]} alt="kito-mascot-1" />
      <KitoBalloon marginLeft="-var(--spacing-m)">{children}</KitoBalloon>
    </div>
  );
}

KitoMascot.propTypes = {
  image: PropTypes.oneOf(['whatToDo', 'buddyForWave', 'whatIs', 'whenToWorry']),
  children: PropTypes.node,
  speech: PropTypes.bool,
  rest: PropTypes.object,
  mascotWidth: PropTypes.number,
};

export default KitoMascot;
